import React, { useEffect, useState } from 'react';
import Pagination from '@material-ui/lab/Pagination';
import NewsCard from './NewsCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNewspaper } from '@fortawesome/free-solid-svg-icons';
import newsApi from '../api/news';
import '../styles/News.css';
import Loading from './Loading';

const SHOW_COUNT = 3;
function News() {
  const [articles, setArticles] = useState([]);
  const [curPage, setCurPage] = useState(1);

  useEffect(() => {
    const fetchArticles = async () => {
      const response = await newsApi.get();
      const newsArticles = response.data.response.docs;
      setArticles(newsArticles);
    };

    fetchArticles();
  }, []);

  const start = (curPage - 1) * SHOW_COUNT;
  const end = start + SHOW_COUNT;
  const displayedArticles = articles.slice(start, end);

  const handlePage = (_, value) => setCurPage(value);

  if (articles.length < 1) return <Loading size={75} />;

  return (
    <section className="news-container">
      <FontAwesomeIcon icon={faNewspaper} size="3x" />
      <h2 id="news__title">News</h2>
      <Pagination
        onChange={handlePage}
        page={curPage}
        count={Math.ceil(articles.length / SHOW_COUNT)}
        variant="outlined"
        color="primary"
      />
      <div id="news">
        {displayedArticles.map((article, index) => (
          <NewsCard key={`${article.web_url}-newscard-${index}`} article={article} />
        ))}
      </div>
    </section>
  );
}

export default News;
